import { createSelector } from 'reselect'
import isCheckoutEsimUpsellExperienceItem from 'loyalty/lib/esims/esimCheckoutUtils'

/** Dedicated paid eSIM post-purchase checkout state. */
const getIsLoyaltyEsimUpsellPostPurchaseCheckout = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (state: App.State) => state.checkout.cart.items,
  (checkoutMode, cartItems): boolean =>
    checkoutMode === 'esim-upgrade' &&
    cartItems.some(item => isCheckoutEsimUpsellExperienceItem(item)),
)

export default getIsLoyaltyEsimUpsellPostPurchaseCheckout
